export default "__VITE_ASSET__wnPMJraa__"